import { jsx as _jsx } from "react/jsx-runtime";
import BaseSkeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export const Skeleton = (props) => _jsx(BaseSkeleton, Object.assign({}, props));
//# sourceMappingURL=index.js.map